import React, { useEffect, useState } from 'react';
import {
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Button,
  DropdownToggle,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Label,
  Input
} from 'reactstrap';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useAuthStore } from '../../../zustand-store/auth.store';
import Spinners from '../Spinner';
import {
  getServicesForBackOffice,
  getAllWorkingDaysForAdmin,
  getAvaliableSlotsByDateForAdmin,
  createAppoinmentFromDashboard,
  updateAppoinmentFromDashboard
} from '../../../axios/customerAppointment/customerAppointment.api';
import { getPatientApi, addPatientApi } from '../../../axios/patient/patient.api';
import { dateFormator } from '../../../utils';
import { toast } from 'react-toastify';
import PhoneInputWithCountrySelect, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { getCurrencySymbol } from '@seamlessslot/shared';
import DeleteModal from '../DeleteModal';

const AppointmentCreateModal = ({
  modal,
  toggle,
  isEdit,
  appoinetmentData,
  type,
  updateMethod,
  closeInnerModal
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isPaidDropdownOpen, setIsPaidDropdownOpen] = useState(false);
  const [showList, setShowList] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [avaliableDates, setAvaliableDates] = useState([]);
  const [avaliableServices, setAvaliableSerivces] = useState([]);
  const [avaliableTime, setAvaliableTime] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const { locationId } = useAuthStore((state) => state);
  const businessId = useAuthStore((state) => state.businessId);
  const [loader, setLoader] = useState(false);
  const [avaliableUsers, setAvaliableUsers] = useState([]);
  const [addUserModal, setAddUserModal] = useState(false);
  const [phoneCheck, setPhoneCheck] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('Pending');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [paymentConfirmMethod, setPaymentConfirmMethod] = useState(null);

  const togglePayment = () => setDropdownOpen(!dropdownOpen);

  const handleStatusChange = (status) => {
    setSelectedStatus(status);
    setIsPaidDropdownOpen(false);
  };

  //const users = [];

  const validationSchema = yup.object().shape({
    selectedService: yup.string().required('Service is required'),
    selectedDate: yup.string().required('Date is required'),
    selectedTime: yup.string().required('Time is required'),
    searchTerm: yup.string().required('Patient name is required'),
    isPaid: yup.string(),
    paymentMethod: yup.string()
  });

  const userValidation = yup.object().shape({
    firstName: yup
      .string()
      .required('Please Enter Your First Name')
      .max(20, 'First Name must be at most 20 characters')
      .matches(/^[A-Za-z\s]+$/, 'First Name cannot contain special characters or numbers'),
    lastName: yup
      .string()
      .required('Please Enter Your Last Name')
      .max(20, 'Last Name must be at most 20 characters')
      .matches(/^[A-Za-z\s]+$/, 'Last Name cannot contain special characters or numbers'),
    // name: yup.string().required('Please Enter Your Name').max(40, 'Name must be at most 40 characters')  .matches(/^[A-Za-z\s]+$/, 'Name cannot contain special characters or numbers'),
    phoneNumber: yup.string().required('Please Enter Your Phone Number'),
    email: yup
      .string()
      .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, 'Please Enter Valid Email')
      .required('Please Enter Your Email'),
    address: yup.string(),
    companyName: yup.string()
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      selectedService: '',
      selectedDate: '',
      selectedTime: '',
      searchTerm: '',
      isPaid: 'no',
      paymentMethod: ''
    },
    validationSchema,
    onSubmit: (values) => {
      if (isEdit) {
        const { startISO, endISO } = extractAndConvertTimes(
          values.selectedDate,
          values.selectedTime
        );
        const payload = {
          startTime: startISO,
          endTime: endISO,
          id: Number.parseInt(appoinetmentData.appointmentId),
          businessId: Number.parseInt(businessId),
          status: selectedStatus
        };
        updateAppoinment(payload);
      } else {
        addAppoinment(values);
      }
    }
  });

  const formikUser = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: '',
      lastName: '',
      name: '',
      phoneNumber: '',
      email: '',
      address: '',
      companyName: '',
      title: '',
      dateOfbirth: '',
      ethnicity: '',
      postcode: '',
      gender: ''
    },
    validationSchema: userValidation,
    onSubmit: async (values) => {
      if (formikUser.values.phoneNumber == '' || phoneCheck) {
        setPhoneCheck(true);
        return;
      }
      const newCustomer = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        address: values.address,
        companyName: values.companyName,
        phoneNo: values.phoneNumber,
        password: 'test',
        locationId: Number.parseInt(locationId),
        businessId: Number.parseInt(businessId),
        ...(values.gender && {
          gender: values.gender === 'true' ? 'Male' : 'Female'
        }),

        ...(values.title && { title: values.title }),

        ...(values.dateofbirth && { dateOfBirth: values.dateofbirth }),

        ...(values.ethnicity && { ethnicity: values.ethnicity }),

        ...(values.postcode && { postCode: values.postcode })
      };

      try {
        const response = await addPatientApi(newCustomer);
        if (response.message == 'success') {
          toast.success(response?.data?.message || 'Customer added');
          newCustomer.id = response?.data?.id;

          const fullName = values?.firstName + ' ' + values?.lastName;
          handleItemClick(fullName, newCustomer);
          formikUser.resetForm();
          toggleUserModal();
          // toggle();
          const modal = document.getElementById('create-appointment-modal');
          if (modal) {
            modal.style.display = 'block';
          }
          fetchAllCustomers();
        }
      } catch (error) {
        console.log('Error in saving customer');
      }
    }
  });

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    formik.setFieldValue('searchTerm', value);

    const match = filteredUsers.some(
      (user) => user?.fullName?.toLowerCase() === value.toLowerCase()
    );
    if (match) {
      setSelectedUser(filteredUsers[0]);
      setShowList(false);
    } else {
      setSelectedUser(null);
      setShowList(true);
    }
  };

  const handleItemClick = (name, user) => {
    setSelectedUser(user);
    setSearchTerm(name);
    setShowList(false);
    formik.setFieldValue('searchTerm', name);
  };

  const handleFocus = () => {
    setShowList(true);
  };

  // const handleBlur = () => {
  //   setTimeout(() => setShowList(false), 200);
  // };

  useEffect(() => {
    setFilteredUsers(
      avaliableUsers.filter((user) =>
        (user?.firstName + ' ' + user?.lastName).toLowerCase().includes(searchTerm?.toLowerCase())
      )
    );
  }, [searchTerm, avaliableUsers]);

  // Reset form and clear localStorage when modal opens
  const resetFormAndState = () => {
    // Clear localStorage for new appointments
    if (!isEdit) {
      localStorage.removeItem('selectedService');
      localStorage.removeItem('selectedDate');
      localStorage.removeItem('selectedTime');
      localStorage.removeItem('clientName');
    }

    // Reset form values
    formik.resetForm();

    // Reset component state
    setSearchTerm('');
    setSelectedUser(null);
    setAvaliableTime([]);
    setSelectedStatus(isEdit ? appoinetmentData?.status || 'Pending' : 'Pending');
    setShowList(false);
    setPhoneCheck(false);
    setIsPaidDropdownOpen(false);
    setDropdownOpen(false);
  };

  const loadData = async () => {
    if (modal) {
      // Reset form first
      resetFormAndState();

      const fetchData = await fetchAllData();

      if (isEdit && appoinetmentData) {
        // Set edit mode values
        formik.setFieldValue('selectedService', appoinetmentData?.serviceId || '');
        formik.setFieldValue(
          'selectedDate',
          appoinetmentData?.appointmentDateDropdown || fetchData[2]?.[0] || ''
        );
        //this we did while updating appointment pre selected time slot as appointment time slot
        getSlots(appoinetmentData?.appointmentDateDropdown, appoinetmentData?.serviceId || 1);
        formik.setFieldValue('selectedTime', appoinetmentData?.appointmentTimeDropdown || '');
        //this we did while updating appointment pre selected time slot as appointment time slot

        formik.setFieldValue('isPaid', appoinetmentData?.paymentStatus == 'Paid' ? 'yes' : 'no');
        formik.setFieldValue('paymentMethod', appoinetmentData?.paymentMethod || '');
        formik.setFieldValue(
          'searchTerm',
          appoinetmentData?.payerName || appoinetmentData?.customerName || ''
        );

        setSearchTerm(appoinetmentData?.payerName || appoinetmentData?.customerName || '');
        setSelectedUser({
          email: appoinetmentData?.customerEmail || '',
          phoneNo: appoinetmentData?.customerPhone || '',
          address: appoinetmentData?.customerAddress || ''
        });
        setSelectedStatus(appoinetmentData?.status || 'Pending');

        // Load available time slots for edit mode
        if (appoinetmentData?.appointmentDateDropdown && appoinetmentData?.serviceId) {
          const payload = {
            date: dateFormator(appoinetmentData?.appointmentDateDropdown),
            locationId: Number.parseInt(locationId),
            serviceId: Number.parseInt(appoinetmentData?.serviceId)
          };
          setAvaliableTime(await getAvaliableSlotsByDateForAdmin(payload));
        }
      }
    }
  };

  useEffect(() => {
    loadData();
  }, [modal, isEdit]);

  const fetchAllData = async () => {
    try {
      setLoader(true);
      const data = await Promise.all([fetchAllCustomers(), fetchAllServices(), getWorkingDays()]);
      setAvaliableDates(data[2] || []);

      // Set default values for new appointments only
      if (!isEdit) {
        // Set default service
        if (data[1]?.length > 0) {
          formik.setFieldValue('selectedService', data[1][0]?.id || '');
        }

        // Set default date (today if available, otherwise next available date from today)
        if (data[2]?.length > 0) {
          const today = new Date();
          const options = { day: '2-digit', month: 'short', year: 'numeric' };
          const formattedToday = today.toLocaleDateString('en-GB', options);

          let selectedDate = data[2][0]; // fallback to first available

          if (data[2].includes(formattedToday)) {
            // Today is available, use it
            selectedDate = formattedToday;
          } else {
            // Find the next available date from today
            const todayTime = today.getTime();
            let nextAvailableDate = null;
            let minTimeDiff = Number.POSITIVE_INFINITY;

            for (const dateStr of data[2]) {
              // Parse the date string (format: "DD MMM YYYY")
              const dateParts = dateStr.split(' ');
              const day = Number.parseInt(dateParts[0]);
              const month = new Date(Date.parse(dateParts[1] + ' 1, 2000')).getMonth();
              const year = Number.parseInt(dateParts[2]);
              const dateTime = new Date(year, month, day).getTime();

              // Check if this date is after today and closer than our current best
              if (dateTime > todayTime && dateTime - todayTime < minTimeDiff) {
                minTimeDiff = dateTime - todayTime;
                nextAvailableDate = dateStr;
              }
            }

            // Use next available date if found, otherwise use first available
            if (nextAvailableDate) {
              selectedDate = nextAvailableDate;
            }
          }

          formik.setFieldValue('selectedDate', selectedDate);

          // Load time slots for default date and service
          if (data[1]?.length > 0) {
            getSlots(selectedDate, data[1][0]?.id);
          }
        }
      }

      return data;
    } catch (error) {
      console.log(error, 'error');
      toast.error('Something Went Wrong');
      return [[], [], []];
    } finally {
      setLoader(false);
    }
  };

  const fetchAllCustomers = async () => {
    try {
      const data = await getPatientApi(locationId);
      if (data?.data?.length > 0) {
        setAvaliableUsers(data?.data);
        setFilteredUsers(data?.data);
      } else {
        setAvaliableUsers([]);
        setFilteredUsers([]);
      }
      return data;
    } catch (error) {
      console.log(error, 'error');
      return { data: [] };
    }
  };

  const fetchAllServices = async () => {
    try {
      const data = await getServicesForBackOffice(locationId);
      if (data?.length > 0) {
        setAvaliableSerivces(data);
      } else {
        setAvaliableSerivces([]);
      }
      return data || [];
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  const getWorkingDays = async () => {
    try {
      const data = await getAllWorkingDaysForAdmin(locationId);
      return data || [];
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  const getSlots = async (date, serviceId) => {
    setAvaliableTime([]);
    formik.setFieldValue('selectedTime', '');

    const selectedServiceId = serviceId || formik.values.selectedService;
    if (!selectedServiceId || !date) return;

    const payload = {
      date: dateFormator(date),
      locationId: Number.parseInt(locationId),
      serviceId: Number.parseInt(selectedServiceId)
    };

    try {
      const slots = await getAvaliableSlotsByDateForAdmin(payload);
      setAvaliableTime(slots || []);
    } catch (error) {
      console.log(error);
      setAvaliableTime([]);
    }
  };

  function extractAndConvertTimes(date, time) {
    const decodedDate = date;
    const decodedTime = time;
    const [startTime, endTime] = decodedTime.split(' - ');

    function toISOString(dateString, timeString) {
      const dateTimeString = `${dateString} ${timeString}`;
      const dateObject = new Date(dateTimeString);
      const year = dateObject.getFullYear();
      const month = String(dateObject.getMonth() + 1).padStart(2, '0');
      const day = String(dateObject.getDate()).padStart(2, '0');
      const hours = String(dateObject.getHours()).padStart(2, '0');
      const minutes = String(dateObject.getMinutes()).padStart(2, '0');
      const seconds = String(dateObject.getSeconds()).padStart(2, '0');
      return !isNaN(dateObject) ? `${year}-${month}-${day}T${hours}:${minutes}:${seconds}` : null;
    }

    const startISO = toISOString(decodedDate, startTime);
    const endISO = toISOString(decodedDate, endTime);

    return {
      startISO,
      endISO
    };
  }

  const addAppoinment = async (values) => {
    if (!selectedUser) {
      toast.error('Please select a customer');
      return;
    }

    setLoader(true);
    const { startISO, endISO } = extractAndConvertTimes(values.selectedDate, values.selectedTime);

    const payload = {
      date: dateFormator(values.selectedDate),
      address: selectedUser?.address || '',
      startTime: startISO,
      endTime: endISO,
      customerId: Number.parseInt(selectedUser?.id),
      locationId: Number.parseInt(locationId),
      serviceId: Number.parseInt(values.selectedService),
      businessId: Number.parseInt(businessId),
      status: selectedStatus
    };

    if (values.isPaid === 'yes') {
      payload.isPaid = values.isPaid;
      payload.paymentMethod = values.paymentMethod;
    }

    try {
      const response = await createAppoinmentFromDashboard(payload);
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.data?.data || 'Appointment created successfully');
        resetFormAndState();
        toggle();
      } else {
        if (Array.isArray(response) && response.length > 0) {
          toast.error(response.join('\n'));
        } else {
          toast.error('Something went wrong');
        }
      }
    } catch (error) {
      toast.error('Error creating appointment');
    } finally {
      setLoader(false);
    }
  };

  const updateAppoinment = async (payload) => {
    setLoader(true);
    try {
      const response = await updateAppoinmentFromDashboard(payload);
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.data?.data || 'Appointment updated successfully');
        resetFormAndState();
        toggle();
        if (type == 'updateAppointment') {
          updateMethod();
          closeInnerModal();
        }
      } else {
        toast.error('Something went wrong');
      }
    } catch (error) {
      toast.error('Error updating appointment');
    } finally {
      setLoader(false);
    }
  };

  const toggleUserModal = () => {
    setAddUserModal(!addUserModal);
    if (!addUserModal) {
      formikUser.resetForm();
      setPhoneCheck(false);
    } else {
      const modal = document.getElementById('create-appointment-modal');
      if (modal) {
        modal.style.display = 'block';
      }
    }
  };

  const setPatientData = (value, type) => {
    formikUser.setFieldValue(type, value);
  };

  function getStatusClass(status) {
    switch (status) {
      case 'Pending':
        return 'bg-warning';
      case 'Confirmed':
        return 'bg-primary confirmed';
      case 'Complete':
        return 'bg-success';
      case 'Cancelled':
        return 'bg-danger';
      case 'No Show':
        return 'bg-dark';
      case 'Follow Up':
        return 'follow-up';
      default:
        return 'bg-primary';
    }
  }

  function isPastDate(dateStr) {
    if (!dateStr) return false;
    const inputDate = new Date(dateStr);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return !(inputDate >= today);
  }

  function changeStatusToConfirmed(date) {
    if (isPastDate(date)) {
      handleStatusChange('Confirmed');
    }
  }

  return (
    <>
      {loader ? (
        <Spinners setLoading={setLoader} />
      ) : (
        <Modal isOpen={modal} toggle={toggle} id="create-appointment-modal">
          <ModalHeader toggle={toggle} tag="h4">
            {isEdit ? 'Edit appointment' : 'Create new appointment'}
          </ModalHeader>
          <ModalBody>
            <div style={{ display: 'flex', justifyContent: 'end' }}>
              {(isEdit ? appoinetmentData?.status : selectedStatus) === 'Confirmed' && !isEdit && (
                <Dropdown isOpen={dropdownOpen} toggle={togglePayment} direction="down">
                  <DropdownToggle caret color="primary" className="mx-2">
                    {formik.values.paymentMethod
                      ? `Paid by ${formik.values.paymentMethod}`
                      : 'Select Payment Method'}{' '}
                    <i className="mdi mdi-chevron-down" />
                  </DropdownToggle>
                  <DropdownMenu>
                    {/* Reset Option */}
                    <DropdownItem
                      onClick={() => {
                        formik.setFieldValue('isPaid', 'no');
                        formik.setFieldValue('paymentMethod', '');
                      }}>
                      <i className="mdi mdi-refresh m-2" title="Reset"></i>
                      {' Select Payment Method'}
                    </DropdownItem>

                    <DropdownItem divider />
                    <DropdownItem
                      onClick={() => {
                        setPaymentConfirmMethod('Cash');
                      }}>
                      <i className="fas fa-money-bill m-2" title="Cash"></i> {'Paid by Cash'}
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setPaymentConfirmMethod('Card');
                      }}>
                      <i className="fa fa-credit-card  m-2" title="Card"></i> {'Paid by Card'}
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              )}

              {isPastDate(formik.values.selectedDate) ? (
                <Button
                  className={`btn  ${
                    isEdit
                      ? getStatusClass(appoinetmentData?.status)
                      : selectedStatus === 'Pending'
                        ? 'btn-warning'
                        : selectedStatus === 'Confirmed'
                          ? 'confirmed'
                          : 'follow-up'
                  }`}>
                  {isEdit ? appoinetmentData?.status : selectedStatus}
                </Button>
              ) : (
                <Dropdown
                  isOpen={isPaidDropdownOpen}
                  toggle={() => {
                    setIsPaidDropdownOpen(!isPaidDropdownOpen);
                  }}>
                  <DropdownToggle
                    tag="button"
                    className={`btn px-3 text-white ${
                      appoinetmentData?.status === 'follow-up'
                        ? 'follow-up'
                        : appoinetmentData?.status?.toLowerCase()
                    }  ${
                      isEdit
                        ? getStatusClass(appoinetmentData?.status)
                        : selectedStatus === 'Pending'
                          ? 'btn-warning'
                          : selectedStatus === 'Confirmed'
                            ? 'confirmed'
                            : 'follow-up'
                    }`}>
                    {isEdit ? appoinetmentData?.status : selectedStatus}
                    {!isEdit && <i className="mdi mdi-chevron-down" />}
                  </DropdownToggle>
                  {!isEdit && (
                    <DropdownMenu className="text-start">
                      <DropdownItem onClick={() => handleStatusChange('Pending')}>
                        Pending
                      </DropdownItem>
                      <DropdownItem onClick={() => handleStatusChange('Follow Up')}>
                        Follow Up
                      </DropdownItem>
                      <DropdownItem onClick={() => handleStatusChange('Confirmed')}>
                        Confirmed
                      </DropdownItem>
                    </DropdownMenu>
                  )}
                </Dropdown>
              )}
            </div>

            <Form onSubmit={formik.handleSubmit}>
              <Row>
                <Col xs={12}>
                  <div className="mb-3">
                    <label className="col-md-12 col-form-label">
                      Select a Service <span style={{ color: 'red' }}>*</span>
                    </label>
                    <div className="col-md-12">
                      <select
                        className="form-control"
                        name="selectedService"
                        onChange={(e) => {
                          formik.handleChange(e);
                          const selectedValue = e.target.value;
                          if (formik.values.selectedDate) {
                            getSlots(formik.values.selectedDate, selectedValue);
                          }
                        }}
                        // style={{opacity:isEdit&&1}}
                        disabled={isEdit}
                        value={formik.values.selectedService || ''}>
                        <option value="" disabled>
                          {avaliableServices.length === 0
                            ? 'No services available'
                            : 'Select service'}
                        </option>
                        {avaliableServices.map((item, index) => (
                          <option key={index} value={item?.id}>
                            {item?.title} ({item?.durationInMinutes}m •{' '}
                            {getCurrencySymbol(item?.currency)}
                            {Number.parseFloat(item?.cost || 0).toFixed(2)})
                          </option>
                        ))}
                      </select>
                      {formik.errors.selectedService && formik.touched.selectedService ? (
                        <div className="text-danger">{formik.errors.selectedService}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="mb-2 row">
                    <div className="col-md-6">
                      <label className="col-form-label">
                        Appointment date <span style={{ color: 'red' }}>*</span>
                      </label>
                      <select
                        className="form-control"
                        name="selectedDate"
                        disabled={!formik.values.selectedService}
                        onChange={(e) => {
                          formik.handleChange(e);
                          const selectedDate = e.target.value;
                          getSlots(selectedDate);
                          changeStatusToConfirmed(selectedDate);
                        }}
                        value={formik.values.selectedDate || ''}>
                        <option value="" disabled>
                          Select date
                        </option>
                        {avaliableDates?.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                      {formik.errors.selectedDate && formik.touched.selectedDate ? (
                        <div className="text-danger">{formik.errors.selectedDate}</div>
                      ) : null}
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label">
                        Time <span style={{ color: 'red' }}>*</span>
                      </label>
                      <select
                        className="form-control"
                        name="selectedTime"
                        disabled={!formik.values.selectedService || !formik.values.selectedDate}
                        onChange={formik.handleChange}
                        value={formik.values.selectedTime || ''}>
                        <option value="" disabled>
                          Select time
                        </option>
                        {avaliableTime?.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                      {formik.errors.selectedTime && formik.touched.selectedTime ? (
                        <div className="text-danger">{formik.errors.selectedTime}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="mb-2">
                    <label htmlFor="example-text-input" className="col-md-12 col-form-label">
                      Customer Name <span style={{ color: 'red' }}>*</span>
                    </label>
                    <div className="col-md-12">
                      <input
                        className="form-control"
                        type="text"
                        name="searchTerm"
                        value={formik.values.searchTerm}
                        onChange={handleInputChange}
                        onFocus={handleFocus}
                        //  onBlur={handleBlur}
                        placeholder="Search name"
                        autoComplete="new-password"
                        disabled={isEdit}
                      />
                      {formik.errors.searchTerm && formik.touched.searchTerm ? (
                        <div className="text-danger">{formik.errors.searchTerm}</div>
                      ) : null}
                    </div>
                    {showList && (
                      <div className="form-control mt-2">
                        <ul
                          className="list-unstyled"
                          style={{ maxHeight: '200px', overflowY: 'auto' }}>
                          {filteredUsers.map((user) => (
                            <li
                              key={user.id}
                              onMouseDown={() => {
                                const fullName = user?.firstName + ' ' + (user?.lastName || '');
                                handleItemClick(fullName, user);
                              }}
                              className="mt-1 clickable-item">
                              {user.firstName} {user?.lastName}
                            </li>
                          ))}
                        </ul>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ height: '100%', cursor: 'pointer' }}
                          onClick={() => {
                            // toggle();
                            const modal = document.getElementById('create-appointment-modal');
                            if (modal) {
                              modal.style.display = 'none';
                            }
                            toggleUserModal();
                          }}>
                          <p className="mb-0">+ Add new customer</p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="mb-2">
                    <label htmlFor="example-text-input" className="col-md-12 col-form-label">
                      Email <span style={{ color: 'red' }}>*</span>
                    </label>
                    <div className="col-md-12">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Search email..."
                        value={selectedUser?.email || ''}
                        readOnly
                        style={{ background: '#F2F2F2', cursor: 'not-allowed' }}
                      />
                    </div>
                  </div>
                  <div className="mb-2">
                    <label htmlFor="example-text-input" className="col-md-12 col-form-label">
                      Phone Number <span style={{ color: 'red' }}>*</span>
                    </label>
                    <div className="col-md-12">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Insert phone number"
                        value={selectedUser?.phoneNo || ''}
                        readOnly
                        style={{ background: '#F2F2F2', cursor: 'not-allowed' }}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col>
                  <div className="text-end">
                    <Button
                      type="submit"
                      className="btn bg-primary"
                      disabled={isEdit && (!formik.dirty || !formik.isValid)}>
                      {isEdit ? 'Update' : 'Create'}
                    </Button>
                  </div>
                  <div className="text-end d-flex justify-content-end">
                    {!isEdit &&
                      selectedStatus !== 'Follow Up' &&
                      selectedStatus !== 'Confirmed' && (
                        <p className="mt-2 col-8">
                          When we create an appointment the customer will receive an email to make
                          the payment
                        </p>
                      )}
                    {!isEdit && selectedStatus === 'Confirmed' && (
                      <p className="mt-2 col-8">
                        {`When an appointment is created without payment, the customer will not receive an email — only a "Confirmed" appointment (unpaid) will be created.`}
                      </p>
                    )}
                    {isEdit && appoinetmentData?.status !== 'Follow Up' && (
                      <p className="mt-2 col-8">
                        When we create an appointment the customer will receive an email to make the
                        payment
                      </p>
                    )}
                  </div>
                </Col>
              </Row>
            </Form>
          </ModalBody>
        </Modal>
      )}
      <Modal isOpen={addUserModal} toggle={toggleUserModal}>
        <ModalHeader toggle={toggleUserModal} tag="h4">
          Add Customer
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              formikUser.handleSubmit();
              return false;
            }}>
            <Row>
              <Col xs={12}>
                <div className="mb-2">
                  <Row>
                    <div className="col-md-6">
                      <label htmlFor="example-text-input" className="col-md-12 col-form-label">
                        First Name <span style={{ color: 'red' }}>*</span>
                      </label>
                      <div className="col-md-12">
                        <input
                          id="firstName"
                          name="firstName"
                          className="form-control"
                          type="text"
                          placeholder="Insert First Name"
                          value={formikUser.values.firstName}
                          onChange={(e) => setPatientData(e.target.value, 'firstName')}
                          onBlur={formikUser.handleBlur}
                        />
                        {formikUser.touched.firstName && formikUser.errors.firstName && (
                          <div className="invalid-feedback d-block">
                            {formikUser.errors.firstName}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="example-text-input" className="col-md-12 col-form-label">
                        Last Name <span style={{ color: 'red' }}>*</span>
                      </label>
                      <div className="col-md-12">
                        <input
                          id="lastName"
                          name="lastName"
                          className="form-control"
                          type="text"
                          placeholder="Insert Last Name"
                          value={formikUser.values.lastName}
                          onChange={(e) => setPatientData(e.target.value, 'lastName')}
                          onBlur={formikUser.handleBlur}
                        />
                        {formikUser.touched.lastName && formikUser.errors.lastName && (
                          <div className="invalid-feedback d-block">
                            {formikUser.errors.lastName}
                          </div>
                        )}
                      </div>
                    </div>
                  </Row>
                </div>

                <div className="mb-2">
                  <label htmlFor="example-text-input" className="col-md-12 col-form-label">
                    Phone Number <span style={{ color: 'red' }}>*</span>
                  </label>
                  <PhoneInputWithCountrySelect
                    placeholder="Enter phone number"
                    name="phoneNumber"
                    value={formikUser.values.phoneNumber}
                    onChange={(value) => {
                      if (!value || !isValidPhoneNumber(value)) {
                        setPhoneCheck(true);
                      } else {
                        setPhoneCheck(false);
                      }
                      formikUser.setFieldValue('phoneNumber', value);
                    }}
                    country="GB"
                    defaultCountry="GB"
                    style={{
                      border: '1px solid #ced4da',
                      paddingLeft: 12,
                      paddingTop: 5,
                      paddingBottom: 5
                    }}
                    //   className="form-control"
                  />
                  {phoneCheck && (
                    <span className="text-danger">
                      {formikUser.values.phoneNumber == ''
                        ? 'Phone number is required'
                        : 'Invalid phone number'}
                    </span>
                  )}
                </div>
                <div className="mb-2">
                  <label htmlFor="example-text-input" className="col-md-12 col-form-label">
                    Email <span style={{ color: 'red' }}>*</span>
                  </label>
                  <div className="col-md-12">
                    <input
                      id="email"
                      name="email"
                      className="form-control"
                      type="text"
                      placeholder="Insert Your email"
                      value={formikUser.values.email}
                      onChange={(e) => setPatientData(e.target.value, 'email')}
                      onBlur={formikUser.handleBlur}
                    />
                    {formikUser.touched.email && formikUser.errors.email && (
                      <div className="invalid-feedback d-block">{formikUser.errors.email}</div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>

            <div className="mb-3">
              <Label className="form-label">Title</Label>
              <Input
                name="title"
                type="select"
                onChange={formikUser.handleChange}
                onBlur={formikUser.handleBlur}
                value={formikUser.values.title || ''}>
                <option value="" disabled>
                  Select title
                </option>
                {[
                  { label: 'Mr', value: 'Mr' },
                  { label: 'Mrs', value: 'Mrs' },
                  { label: 'Miss', value: 'Miss' },
                  { label: 'Ms', value: 'Ms' },
                  { label: 'Dr', value: 'Dr' },
                  { label: 'Master', value: 'Master' },
                  { label: 'Prof', value: 'Prof' },
                  { label: 'Hon', value: 'Hon' },
                  { label: 'Rev', value: 'Rev' },
                  { label: 'Sir', value: 'Sir' },
                  { label: 'Lady', value: 'Lady' },
                  { label: 'Lord', value: 'Lord' },
                  { label: 'Earl', value: 'Earl' },
                  { label: 'Judge', value: 'Judge' },
                  { label: 'Dame', value: 'Dame' }
                ].map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Input>
            </div>
            <div className="mb-3">
              <Label className="form-label">Date of Birth</Label>
              <Input
                name="dateofbirth"
                type="date"
                onChange={formikUser.handleChange}
                onBlur={formikUser.handleBlur}
                value={
                  formikUser.values.dateofbirth ? formikUser.values.dateofbirth.split('T')[0] : ''
                }
                max={new Date().toISOString().split('T')[0]}
              />
            </div>
            <div className="mb-3">
              <Label className="form-label">Gender</Label>
              <Input
                name="gender"
                type="select"
                onChange={formikUser.handleChange}
                onBlur={formikUser.handleBlur}
                value={formikUser.values.gender ?? ''}>
                <option value="" disabled>
                  Select gender
                </option>
                <option value="true">Male</option>
                <option value="false">Female</option>
              </Input>
            </div>
            <div className="mb-3">
              <Label className="form-label">Ethnicity</Label>
              <Input
                name="ethnicity"
                type="select"
                onChange={formikUser.handleChange}
                onBlur={formikUser.handleBlur}
                value={formikUser.values.ethnicity || ''}>
                <option value="" disabled>
                  Select ethnicity
                </option>
                {/* White */}
                <optgroup label="White">
                  <option value="White British">White British</option>
                  <option value="White Irish">White Irish</option>
                  <option value="White Other">White Other</option>
                </optgroup>

                {/* Black / African / Caribbean */}
                <optgroup label="Black / African / Caribbean / Black British">
                  <option value="Black or Black British Caribbean">
                    Black or Black British Caribbean
                  </option>
                  <option value="Black or Black British African">
                    Black or Black British African
                  </option>
                  <option value="Other Black Background">Other Black Background</option>
                </optgroup>

                {/* Asian */}
                <optgroup label="Asian / Asian British">
                  <option value="Asian or Asian British Indian">
                    Asian or Asian British Indian
                  </option>
                  <option value="Asian or Asian British Pakistani">
                    Asian or Asian British Pakistani
                  </option>
                  <option value="Asian or Asian British Bangladeshi">
                    Asian or Asian British Bangladeshi
                  </option>
                  <option value="Other Asian Background">Other Asian Background</option>
                  <option value="Chinese">Chinese</option>
                </optgroup>

                {/* Mixed */}
                <optgroup label="Mixed / Multiple Ethnic Groups">
                  <option value="White and Black Caribbean">White and Black Caribbean</option>
                  <option value="White and Black African">White and Black African</option>
                  <option value="White and Asian">White and Asian</option>
                  <option value="Other Mixed Background">Other Mixed Background</option>
                </optgroup>

                {/* Other */}
                <optgroup label="Other Ethnic Group">
                  <option value="Any Other Ethnic Group">Any Other Ethnic Group</option>
                  <option value="Patient Declined">Patient Declined</option>
                </optgroup>
              </Input>
            </div>
            <div className="mb-3">
              <Label className="form-label">Address</Label>
              <Input
                name="address"
                type="textarea"
                placeholder="Enter address"
                rows="3"
                onChange={formikUser.handleChange}
                onBlur={formikUser.handleBlur}
                value={formikUser.values.address || ''}
              />
            </div>
            <div className="mb-3">
              <Label className="form-label">Postcode</Label>
              <Input
                name="postcode"
                type="text"
                placeholder="Enter postcode"
                onChange={(e) => {
                  e.target.value = e.target.value.toUpperCase();
                  formikUser.handleChange(e);
                }}
                onBlur={formikUser.handleBlur}
                value={formikUser.values.postcode || ''}
                maxLength={8}
              />
            </div>
            <Row className="mt-2">
              <Col>
                <div className="text-end">
                  <Button
                    type="submit"
                    className="save-user bg-purple"
                    color="primary"
                    disabled={!(formikUser.isValid && formikUser.dirty)}>
                    Create
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
      <DeleteModal
        show={!!paymentConfirmMethod}
        buttonTitle="Confirm"
        Label="Confirm Payment"
        heading="Please confirm that payment has been received. Once marked as paid, this appointment cannot be reverted."
        onDeleteClick={() => {
          formik.setFieldValue('isPaid', 'yes');
          formik.setFieldValue('paymentMethod', paymentConfirmMethod);
          setPaymentConfirmMethod(null);
        }}
        onCloseClick={() => setPaymentConfirmMethod(null)}
      />
    </>
  );
};

AppointmentCreateModal.propTypes = {
  modal: PropTypes.bool,
  toggle: PropTypes.func,
  isEdit: PropTypes.bool,
  appoinetmentData: PropTypes.any,
  type: PropTypes.any,
  updateMethod: PropTypes.any,
  closeInnerModal: PropTypes.any
};

export default AppointmentCreateModal;
